// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","box":"Card_box__1FJKN","header":"Card_header__21_95","section":"Card_section__3GA2K","closeIcon":"Card_closeIcon__2YuND"};